module.exports = __webpack_public_path__ + "img/about-hero.1ca8f345.jpg";